import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import vision from "../../../assets/images/about/aboutCompanyOverview/vision.png";
import mission from "../../../assets/images/about/aboutCompanyOverview/mission.png";
import ourValues from "../../../assets/images/about/aboutCompanyOverview/ourValues.png";

interface ImageData {
    src: string;
    text: string;
    description: string;
}
const imageData: ImageData[] = [
    { src: vision, text: "VISION ", description: "To be a leader in the construction industry by delivering innovative, high-quality, and sustainable solutions that shape the future and enhance communities." },
    { src: mission, text: "MISSION ", description: "To provide exceptional craftsmanship, cutting-edge designs, and customer-focused services, ensuring every project is built with precision, integrity, and excellence." },
    { src: ourValues, text: "OUR VALUES ", description: "We believe in quality craftsmanship, innovation, and trust, ensuring every project meets the highest industry standards while exceeding client expectations." }
];

const AboutCompanyOverview = () => {
    return (
        <div className='aboutCompanyOverviewContainer'>
            <div className='aboutCompanyOverviewContents'>
                <div className='aboutCompanyOverviewTitle'>
                    <span>VISION & MISSION</span>
                </div>
                <div className='aboutCompanyOverviewContentContainer'>
                    <div className='aboutCompanyOverviewContent'>
                        Here are our Vision and Mission, reflecting our commitment to excellence, innovation, and quality, ensuring sustainable and outstanding structures.
                    </div>
                    <div className='aboutCompanyOverviewImageContent'>
                        {imageData.map((item, index) => (
                            <div key={index} className='aboutCompanyOverviewImageTextContainer'>
                                <LazyLoadImage
                                    draggable={false}
                                    src={item.src}
                                    alt={`aboutTheBrand-${index + 1}`}
                                    effect="blur"
                                    width="375"
                                    height="300"
                                />
                                <div className='aboutCompanyOverviewText'>{item.text}</div>
                                <div className='aboutCompanyOverviewDescription'>{item.description}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutCompanyOverview